import { INVENTORY_KASIR } from "../../constants/admin/masterdata/constants";

const initialState = {
  dataInventoryKasir: { count: 0, data: [] },
  loadingGetInventoryKasir: true,
};

const inventoryKasirReducer = (state = initialState, action) => {
  switch (action.type) {
    case INVENTORY_KASIR.LOADING_DATA_INVENTORY_KASIR:
      return {
        ...state,
        loadingGetInventoryKasir: action.load,
      };

    case INVENTORY_KASIR.GET_DATA_INVENTORY_KASIR_SUCCESS:
      return {
        ...state,
        dataInventoryKasir: action.data,
        loadingGetInventoryKasir: false,
      };

    default:
      return state;
  }
};

export default inventoryKasirReducer;
